module.exports = __webpack_public_path__ + "img/niunai6.f4fdcc68.jpg";